.month {
  border-collapse: collapse;
  table-layout: fixed;

  &[data-full-width] {
    width: 100%;
  }
}

.monthCell {
  padding: 0;

  &:where([data-with-spacing]) {
    padding: 0.5px;
  }
}

.weekNumber {
  --wn-size-xs: 30px;
  --wn-size-sm: 36px;
  --wn-size-md: 42px;
  --wn-size-lg: 48px;
  --wn-size-xl: 54px;

  color: var(--mantine-color-dimmed);
  font-weight: var(--mantine-font-weight-regular);
  font-size: calc(var(--wn-size, var(--wn-size-sm)) / 2.8);
  text-align: center;
  width: var(--wn-size, var(--wn-size-sm));
}
